/* línkè · 活动实时窗 数据源（路线图任务 ④）=========================
   全局环形缓冲：聊天流里的 tool_use / tool_result 等事件顺手塞进来，
   ActivityWindow 组件订阅它、像终端一样实时渲染。

   纯前端、零后端：料就是 src/api/chat.js streamChat 已经在吐的 SSE 事件
   （API 模式 + 深度模式都吐 tool_use/tool_result，见 Chat.jsx onEvent）。
   只在「活动实时窗」开关开着时才真正 push（Chat.jsx 里 gate），不占资源。
   ================================================================ */
import { useState, useEffect } from 'react';

const MAX = 200; // FIFO 上限，超了丢最老的
let _buf = [];
let _seq = 0;
const _listeners = new Set();

function _emit() {
  _listeners.forEach((fn) => {
    try {
      fn(_buf);
    } catch {}
  });
}

/* 追加一条活动。kind: 'tool_use'|'tool_result'|'info'|'error'
   data: { name?, summary?, ok?, text? } */
export function pushActivity(kind, data = {}) {
  const entry = { id: ++_seq, ts: Date.now(), kind, ...data };
  _buf = _buf.length >= MAX ? [..._buf.slice(_buf.length - MAX + 1), entry] : [..._buf, entry];
  _emit();
}

export function clearActivity() {
  _buf = [];
  _emit();
}

export function getActivity() {
  return _buf;
}

/* React hook：订阅整条日志（返回数组引用，变了就重渲染）。 */
export function useActivityLog() {
  const [log, setLog] = useState(_buf);
  useEffect(() => {
    setLog(_buf);
    _listeners.add(setLog);
    return () => _listeners.delete(setLog);
  }, []);
  return log;
}
